import styles from "./vendors.module.scss";
import * as React from "react";
import Header from "@components/Header";
import Footer from "@components/Footer";
import VendorsSection2 from "@components/VendorsSection2";
import VendorsHero from "@components/VendorsHero";
import VendorsSection1 from "@components/VendorsSection1";

const Vendors = () => {
  React.useEffect(() => {
    // GSDevTools.create();
  }, []);

  return (
    <div className={styles["vendors"]} data-scroll-section>
      <Header />
      <VendorsHero />
      <VendorsSection1 />
      <VendorsSection2 />
      <Footer vendorsPage />
    </div>
  );
};

export default Vendors;
